import React from 'react';
import { Router, Redirect, Switch, Route } from "react-router-dom";
import {Boton} from '../comun/Index';
import Nuevo from './Nuevo';
import Pendientes from './Pendientes';

export default class Mesa extends React.Component{
  constructor(props){
    super(props);
    this.state = {}
  }

  render(){
    return(
      <Router history={this.props.history}>
        <div className="Todo Configuraciones">
          <div style={{display:'flex', flexDirection:'row', width:'90%', justifyContent:'center', marginBottom:15}}>
            <Boton
              backgroundColor="#fc664b"
              titulo="Nuevo"
              onClick={() => this.props.history.push('/mesa/nuevo')}
            />
            <Boton
              backgroundColor="#fc664b"
              titulo="Pendientes"
              onClick={() => this.props.history.push('/mesa/pendientes')}
            />
          </div>
          <Switch>
            <Route
              path="/mesa/nuevo"
              component={(props) =>
                <Nuevo
                  finalizar={() => this.props.history.push('/mesa/pendientes')} 
                />
              }
            />
            <Route
              path="/mesa/pendientes"
              component={(props) =>
                <Pendientes />
              }
            />
            <Route exact path="/mesa">
              <Redirect to="/mesa/nuevo" />
            </Route>
            <Route path="/mesa/*">
              <Redirect to="/mesa/nuevo" />
            </Route>
          </Switch>
        </div>
      </Router>
    )
  }
}